import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { cn } from "@/lib/utils";

export default function ChatImage({ path, className }) {
  const [url, setUrl] = useState(null);
  const [err, setErr] = useState(false);
  const isHttp = typeof path === "string" && path.startsWith("http");
  useEffect(() => {
    if (isHttp) { setUrl(path); return; }
    let revoke;
    api.get(`/files/${path}`, { responseType: "blob" })
      .then((r) => { const u = URL.createObjectURL(r.data); revoke = u; setUrl(u); })
      .catch(() => setErr(true));
    return () => { if (revoke) URL.revokeObjectURL(revoke); };
  }, [path, isHttp]);
  if (err) return <div className="text-xs opacity-60">Image indisponible</div>;
  if (!url) return <div className={cn("bg-black/10 animate-pulse rounded", className || "h-32 w-48")} />;
  return <img src={url} alt="" className={className || "max-w-[220px] max-h-64 rounded object-cover"} data-testid="chat-image" />;
}
